import helm from '@/assets/ico/vendor/helm.svg?c';

import { BadgeIcon } from '@@/BadgeIcon';

export const HelmIcon = <BadgeIcon icon={helm} />;
